import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { RevealLines, FadeUp } from "@/components/Reveal";

const STEPS = [
  ["01", "Wander in", "Read the thoughts strangers left under the lavender moon."],
  ["02", "Whisper back", "Sign in with Google and leave a dream, wish, secret or memory."],
  ["03", "Keep it close", "Choose a Lavender Hollow bracelet to carry your story at the wrist."],
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} className="relative py-24 md:py-36 overflow-hidden" data-testid="about-section">
      <div className="absolute inset-0">
        <img src="/img/sky-a.jpg" alt="" className="w-full h-full object-cover" data-testid="about-bg" />
      </div>
      <div className="absolute inset-0 bg-[#0e0616]/65" />
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#0e0616] to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#0e0616] to-transparent" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative h-[440px] md:h-[560px] overflow-hidden rounded-t-full">
          <motion.img style={{ y }} src="/img/lady.jpg" alt="A lavender-haired woman in a dark gown under a glowing moon"
            className="absolute -inset-y-[10%] inset-x-0 w-full h-[120%] object-cover object-top" data-testid="about-art" />
        </div>
        <div className="lg:col-span-7 lg:pl-10">
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-purple-300 mb-6">I — The Hollow</p>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight">
            <RevealLines inView lines={[<>A place that</>, <>feels like <em className="text-purple-300">dusk</em>.</>]} />
          </h2>
          <ol className="mt-12 space-y-0">
            {STEPS.map(([n, t, d], i) => (
              <FadeUp key={n} delay={i * 0.1}>
                <li className="group grid grid-cols-[56px_1fr] gap-4 py-6 border-t border-purple-400/20" data-testid={`about-step-${n}`}>
                  <span className="font-mono text-sm text-amber-200 pt-1">{n}</span>
                  <div>
                    <p className="font-display text-3xl transition-transform duration-500 group-hover:translate-x-2">{t}</p>
                    <p className="mt-2 text-purple-100/85">{d}</p>
                  </div>
                </li>
              </FadeUp>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
